module.exports = __webpack_public_path__ + "assets/1.png";


//////////////////
// WEBPACK FOOTER
// ./images/1.png
// module id = 566
// module chunks = 0